import Typography from '@mui/material/Typography';
import React from 'react';

import { EmptyFieldValueRenderer } from '@/components/molecules/EmptyFieldValueRenderer';
import { useTranslator } from '@/hooks/useTranslator';
import { MultipleValuesField, SelectItem } from '@/types/fields';

interface Props {
  readonly value: unknown;
  readonly field: MultipleValuesField<unknown>;
}
export const MultipleValuesFieldValueRenderer: React.FC<Props> = (
  props: Props,
): React.ReactElement => {
  const { value, field } = props;
  const { items } = field;

  const tr = useTranslator();

  if (!Array.isArray(value)) {
    console.debug('expected array, got', value, 'of type', typeof value, 'instead');
    return <EmptyFieldValueRenderer />;
  }

  return (
    <Typography variant="body2" color="text.primary">
      {items
        .filter((item: SelectItem): boolean => value.includes(item.value))
        .map((item: SelectItem): string => tr(item.label))
        .join(', ')}
    </Typography>
  );
};
